import React from 'react'
import styles from './traders.module.css'

export default function SubHeader() {
    return (
        <div>
            <div className={styles.sortingOptions} data-listing-sorting="true" data-listing-sorting-options="{&quot;sorting&quot;:&quot;price-desc&quot;}">
                <select class="sorting custom-select" aria-label="Sorting">
                    <option value="price-asc" selected="">Date descending / Newest First</option>
                    <option value="price-asc">Date ascending / Oldest First</option>
                    <option value="price-desc" >Price descending</option>
                    <option value="price-asc">Price ascending</option>
                    <option value="name-asc">Sorting name A-Z</option>
                    <option value="name-desc">Sorting name Z-A</option>
                    <option value="topseller">Topseller</option>
                </select>
            </div>
        </div>
    )
}
